export type ValidationStatus = 'dirty' | 'non-compliant' | 'compliant';

/**
 * Mirrors legacy Angular `validationStatus(item)` in items-controller.js:
 * dirty takes precedence; otherwise any errors/warnings → non-compliant;
 * else compliant (no validation icon).
 */
export const validationStatus = (item: {
    validation_dirty__?: boolean;
    validation__?: string[] | null;
    validation_warnings__?: string[] | null;
}): ValidationStatus => {
    if (item.validation_dirty__ === true) {
        return 'dirty';
    }
    if ((item.validation__?.length ?? 0) > 0 || (item.validation_warnings__?.length ?? 0) > 0) {
        return 'non-compliant';
    }
    return 'compliant';
};
